import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "motion/react";
import { NavigationModuleProvider } from "@agp/shared.user-app/application/context/navigation";
import { PagePaths } from "@agp/shared.user-app/application/context/navigation/type";
import { NavigationCoreModuleProvider } from "../../../domain/context/navigation-core";
import { useNavigationCoreModule } from "../../../domain/module/navigation-core";
import { useQueryModule } from "../../../domain/module/query";
import { useNavigationModule } from "../../../domain/module/navigation";
import { applicationConfig } from "../../../infrastructure/application-config";
import React, { useEffect, useState } from "react";
import ServiceLocator from "../../../domain/service-locator";

// General版のページインポート
import TopPage from "./pages/top/top";
import ToursPage from "./pages/tours/tours";
import AreasPage from "./pages/areas/areas";
import GuidesPage from "./pages/guides/guides";
import MapPage from "./pages/map/map";
import NotePage from "./pages/note/note";
import RootPage from "./pages/root/root";
import { GeneralAudioPlayerContainer } from "./containers/player/general-audio-player-container";

const Router = () => {
  const location = useLocation();

  // Create Modules
  const navigationCoreModule = useNavigationCoreModule();
  const navigationModule = useNavigationModule(
    applicationConfig,
    navigationCoreModule
  );
  useQueryModule();

  const activityLogModule = ServiceLocator.ActivityLogModule;
  useEffect(() => {
    activityLogModule.sendPageViewEvent(location.pathname, location.pathname);
  }, [location.pathname]);

  return (
    <NavigationCoreModuleProvider module={navigationCoreModule}>
      <NavigationModuleProvider module={navigationModule}>
        <AnimatePresence mode="wait" initial={false}>
          <Routes location={location} key={location.pathname}>
            <Route path={PagePaths.note} element={<NotePage />} />
            <Route path={PagePaths.top} element={<TopPage />} />
            <Route path={PagePaths.areas} element={<AreasPage />} />
            <Route path={PagePaths.tours} element={<ToursPage />} />
            <Route path={PagePaths.guides} element={<GuidesPage />} />
            <Route path={PagePaths.map} element={<MapPage />} />
            <Route path={PagePaths.root} element={<RootPage />} />
            <Route path="/*" element={<NotFoundPage />} />
          </Routes>
        </AnimatePresence>
      </NavigationModuleProvider>
    </NavigationCoreModuleProvider>
  );
};

const NotFoundPage = () => <div>Not Found</div>;

const GeneralAppContainer = () => {
  const playerType = ServiceLocator.PlayerLayoutModule.playerType.watch();
  const theme = ServiceLocator.ThemeStore.theme;
  const [showDeepBackground, setShowDeepBackground] = useState<boolean>(false);

  return (
    <>
      {showDeepBackground && <div className="absolute inset-0 bg-black" />}
      <motion.div
        className="overflow-hidden h-[calc(var(--vh,1vh)*100)]"
        style={{
          background: theme.color.primaryBackground,
        }}
        animate={{
          scale: playerType === "full" ? 0.9 : 1,
          y: playerType === "full" ? "-4%" : 0,
          borderRadius: playerType == "full" ? 20 : 0,
        }}
        transition={{
          type: "tween",
          duration: 0.3,
        }}
        onAnimationStart={() =>
          playerType === "full" && setShowDeepBackground(true)
        }
        onAnimationComplete={() =>
          playerType !== "full" && setShowDeepBackground(false)
        }
      >
        <BrowserRouter>
          <Router />
        </BrowserRouter>
        <motion.div
          animate={{
            opacity: playerType === "full" ? 0.5 : 0,
          }}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 3000,
            pointerEvents: "none",
            background: theme.color.secondaryBackground,
          }}
        />
      </motion.div>
      <GeneralAudioPlayerContainer />
    </>
  );
};

export default GeneralAppContainer;
